import Swiper, { Autoplay, EffectFade, Pagination } from 'swiper'

Swiper.use([Autoplay, EffectFade, Pagination])

const fn = {
  init: () => {
    document.querySelectorAll('.panel-slider').forEach((el) => fn.setupSlider(el))
  },

  setupSlider: (el) => {
    const container = el.querySelector('.swiper')
    const numSlides = container.querySelectorAll('.swiper-slide').length
    const parentContainer = container.closest('.panel-slider-container')

    const opts = {
      speed: 1000,
      autoplay: {
        delay: 4000,
      },
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      pagination: {
        el: container.querySelector('.panel-slider-pagination'),
        clickable: true,
      },
    }

    if (numSlides > 1) {
      const swiper = new Swiper(container, opts)

      swiper.on('slideChangeTransitionStart', (swiper) => {
        fn.setActiveSlide(parentContainer, swiper.realIndex)
      })

      parentContainer.querySelectorAll('.panel-slider-text-pagination button').forEach((el) => {
        el.addEventListener('click', (e) => {
          swiper.slideTo(e.target.dataset.index)
        })
      })
    }
  },

  setActiveSlide: (container, index) => {
    const textPagination = container.querySelector('.panel-slider-text-pagination')
    const item = Array.from(textPagination.querySelectorAll('li'))[index]

    if (item) {
      textPagination.querySelector('.is-active').classList.remove('is-active')
      item.classList.add('is-active')
    }
  },
}

export default {
  can: () => true,
  run: fn.init,
}
